module.exports = __webpack_public_path__ + "img/iprod-site-web.047ccfa.jpg";